<template>
  <AIMainPage />
</template>

<script>
/* eslint-disable */
import AIMainPage from '@/components/ai/AIMainPage.vue';

export default {
  name: 'AIPage',
  components: {
    AIMainPage
  },
  data() {
    return {
    };
  },
};
</script>

